import React from "react";
import { strings } from "../../resources/strings";

export interface WelcomeScreenProps {
  /** Advance the wizard to the first question. */
  onStart: () => void;
}

/**
 * Welcome screen shown before question 1 of the Report Form wizard.
 *
 * Presentational only — introductory copy plus a Start button that advances the
 * wizard. Mirrors Figma "iOS - Welcome 1" (node 21:5355).
 */
const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onStart }) => {
  return (
    <div
      data-testid="welcome-screen"
      className="flex flex-col items-center text-center px-2 pt-6 pb-2"
    >
      <h2 className="text-2xl font-semibold text-gray-900 mb-6 max-w-md">
        {strings.reportForm.welcomeHeading}
      </h2>
      <p className="text-base text-gray-900 mb-6 max-w-md">
        {strings.reportForm.welcomeBody}
      </p>
      <p className="text-base text-gray-700 mb-10 max-w-md">
        {strings.reportForm.welcomeHint}
      </p>
      <button
        type="button"
        onClick={onStart}
        className="w-full max-w-md min-h-[44px] h-16 rounded-2xl bg-primary text-accent text-base font-semibold shadow-md transition-all duration-200 hover:opacity-90 active:scale-95"
      >
        {strings.reportForm.start}
      </button>
    </div>
  );
};

export default WelcomeScreen;
